import React from 'react';
import {loginSelectors} from 'features/login/redux';
import {useSelector} from 'react-redux';
import dayjs from 'dayjs';
import {FILE_DF} from 'common/formats';

export const useDefaultBackupFileName = () => {
   const appVersion = useSelector(loginSelectors.getApplVersion);

   const name = React.useMemo(
      () => `DiplomatBackup.${appVersion.replace(' ', '.')}.${dayjs().format(FILE_DF)}`,
      [appVersion]
   );

   return name;
};
